function getStatusClass(reference) {
  return (reference.ref && reference.ref.status) || 'none'
}

function Nest(items) {
  let mapping = items.reduce((res, cur, i, source) => {
    let children = source.filter(s => s.parent && s.parent.id === cur.id)
    if (children.length) res[cur.id] = children

    return res
  }, {})

  let roots = items.filter(f => !f.parent).sort((a, b) => (a.isEntry && !b.isEntry ? -1 : 0))

  const build = (items, level = 0) => {
    let arr = []
    items.forEach(item => {
      arr.push({ ...item, level })
      if (mapping[item.id]) arr.push(...build(mapping[item.id], level + 1))
    })

    return arr
  }

  return build(roots)
}

export { getStatusClass, Nest }
